export const queryHouseStatistic = '/erp/house/housingResources/queryHouseStatistic'; //房源状态分析

export const querySaleStatistic = '/erp/house/housingResources/querySaleStatistic'; //二手房销售分析

export const queryHalfAdd = '/erp/house/housingResources/queryHalfAdd'; //近半年新增房源

export const businessAnalysis = '/erp/house/housingResources/businessAnalysis'; //房源业务分析

export const queryEmployeeChangeStatistic = '/erp/employee/statistic/queryEmployeeChangeStatistic'; //人员变化情况

export const queryEmployeeRoleStatistic = '/erp/employee/statistic/queryEmployeeRoleStatistic'; //岗位分布

export const queryEmployeeStatistic = '/erp/employee/statistic/queryEmployeeStatistic'; //员工人力分析

export const queryHouseCustomerStatistic = '/erp/employee/statistic/queryHouseCustomerStatistic'; //房源统计列表